import axios from 'axios';
import apiUrl from '../constants';

export function removeSalesDemoService(token){
     return axios({
        method: 'post',
        url: apiUrl.api_url + 'removeSalesDemo',
        headers: {
          'Authorization': 'Bearer ' + token
        }
      });
}


// WEBPACK FOOTER //
// ./src/services/removeSalesDemo.js